<template>
  <notifications classes="mt-5 mr-5 vue-notification"/>
  <router-view/>
</template>
